<h2 class="h5">{{ 'product-specificaties-titel' | fromDictionary }}</h2>

<dl class="dl-list type-body-sm">
  <div class="d-contents" *ngFor="let spec of specs; trackBy: trackByFn">
    <div class="dl-list__row" *ngIf="spec.type !== 'links'">
      <dt>{{ ('product-specificatie-' + spec.key | fromDictionary:false) || (spec.key | titlecase) }}</dt>
      <dd>{{ printValue(spec) }}</dd>
    </div>
    <div class="dl-list__row" *ngIf="spec.type === 'links' && spec?.links?.length">
      <dt>{{ ('product-specificatie-' + spec.key | fromDictionary:false) || (spec.key | titlecase) }}</dt>
      <dd>
        <ul class="link-list">
          <li class="link-list__item" *ngFor="let link of spec?.links; trackBy: trackByLinks; let i = index">
            <a [routerLink]="['/collections', link.handle]">{{ link.title + (i === (spec?.links)!.length - 1 ? '' : ',') }}</a>
          </li>
        </ul>
      </dd>
    </div>
  </div>
</dl>
